import * as Yup from 'yup';

import { FormTypes, FormFields } from 'src/typings/forms';
import { locals } from 'src/constants';
import { appTranslations } from 'src/constants/locals/appTranslation';
import { IStandartContactForm } from 'src/typings/app';

export const getBookNowFormSchema = (bookNowFormData: {standardForm: IStandartContactForm | null | undefined, defaultCountry: string}, isMarketplace: boolean) => [
  {
    fieldType: FormTypes.text,
    name: FormFields.bio,
    type: 'text',
    initialValue: '',
    placeholder: appTranslations.appUserName,
    options: {
      style: {
        '& .MuiInputLabel-formControl': {
          fontSize: isMarketplace ? '16px' : '',
          fontWeight: '400',
          '@media (max-width: 768px)': {
            fontSize: '14px',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: isMarketplace ? '16px' : '',
        },
        '& .MuiInputBase-formControl': {
          borderRadius: isMarketplace ? '16px' : '',
        },
      },
    },
  },
  {
    fieldType: FormTypes.phone,
    name: FormFields.phone,
    type: 'tel',
    initialValue: '',
    placeholder: appTranslations.appPhoneNumber,
    validation: Yup.string()
      .required(appTranslations.appErrorFieldIsRequired),
    options: {
      defaultCountry: bookNowFormData.defaultCountry || 'ua',
      mask: '+38 999 999 99 99',
      style: {
        '& .MuiInputLabel-formControl': {
          fontSize: '10px',
          fontWeight: '400',
          top: '4px',
          transform: 'translate(16px, -10px)!important',
          color: 'rgba(30,30,30, .7)',
          '& legend': {
            display: 'none',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: isMarketplace ? '16px' : '',
        },
        '& .MuiInputBase-formControl': {
          borderRadius: isMarketplace ? '16px' : '',
          '& .MuiPhoneNumber-flagButton': {
            minWidth: '24px',
            width: '24px',
            height: '20px',
            overflow: 'hidden',
            borderRadius: '4px',
          },
          '& .MuiPhoneNumber-positionStart': {
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            '& svg.margin': {
              transform: 'scale(1.2)',
            },
            '& span': {
              display: 'none',
            },
            '&:after': {
              content: '""',
              width: '8px',
              height: '4px',
              backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'8\' height=\'4\' fill=\'none\'%3E%3Cpath stroke=\'%231E1E1E\' stroke-linecap=\'round\' stroke-linejoin=\'round\' d=\'m1 .5 3 3 3-3\'/%3E%3C/svg%3E")',
              display: 'inline-block',
            },
          },
        },
      },
    },
  },
  {
    fieldType: FormTypes.email,
    name: FormFields.email,
    type: 'email',
    initialValue: '',
    placeholder: appTranslations.appEmail,
    validation: Yup.string()
      .email(locals.appTranslations.appErrorEmailFormat),
    options: {
      style: {
        '& .MuiInputLabel-formControl': {
          fontSize: isMarketplace ? '16px' : '',
          fontWeight: '400',
          '@media (max-width: 768px)': {
            fontSize: '14px',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: isMarketplace ? '16px' : '',
        },
        '& .MuiInputBase-formControl': {
          borderRadius: isMarketplace ? '16px' : '',
        },
      },
    },
  },
  {
    fieldType: FormTypes.textarea,
    name: FormFields.additionalInfo,
    type: 'text',
    initialValue: '',
    placeholder: appTranslations.additionalInfo,
    options: {
      style: {
        '& .MuiInputLabel-formControl': {
          fontSize: isMarketplace ? '16px' : '',
          fontWeight: '400',
          '@media (max-width: 768px)': {
            fontSize: '14px',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: isMarketplace ? '16px' : '',
          height: isMarketplace ? '139px!important' : '',
        },
        '& .MuiInputBase-formControl': {
          borderRadius: isMarketplace ? '16px' : '',
          '@media (max-width: 768px)': {
            height: '172px',
          },
        },
      },
    },
  },
  {
    fieldType: FormTypes.hidden,
    name: FormFields.url,
    type: 'hidden',
    initialValue: document.location.href,
    placeholder: '',
    options: {
      style: {
        '& .MuiInputLabel-formControl': {
          fontSize: isMarketplace ? '16px' : '',
          fontWeight: '400',
        },
        '& .MuiInputBase-formControl': {
          borderRadius: isMarketplace ? '16px' : '',
        },
      },
    },
  },
];
